module.exports = __webpack_public_path__ + "media/images/gifts/movement/sug_movimento_3-a0bfb14329f92a69094e81c52c9c2039.jpg";